// auto-hook-datepicker.directive.ts
import {Directive, inject, OnInit} from '@angular/core';
import {DatePicker} from 'primeng/datepicker';
import {SDKConfig} from '../sdk.config';

@Directive({
    selector: '[appPDatePickerFix], p-datepicker',
    exportAs: 'appPDatePickerFix'
})
export class PDatePickerFixDirective implements OnInit {
    private readonly _datePicker: DatePicker = inject(DatePicker);

    // ===============================================================
    // ===============================================================

    /**
     * On init
     */
    ngOnInit(): void {
        if (!this._datePicker) return;

        this._datePicker.panelStyleClass = 'sdk-datepicker-fix';
        if (!this._datePicker.dateFormat) this._datePicker.dateFormat = SDKConfig.datePickerDateFormat;
        if (!this._datePicker.hourFormat) this._datePicker.hourFormat = SDKConfig.datePickerHourFormat;
    }
}
